export interface PPSRRegisterDialogData {
  message: string;
  subMessage: string;
}

export interface PPSRRegisterDialogResult {
}
